'use strict';

/**
 * List item for the trash list
 *
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');
var Util = require('base/Colido.Util');

var template = require('../../templates/partials/trash-list-item.hbs');

var ImportTrashListItem = ColidoItemView.extend({
    template: template,

    tagName: 'tr',

    modelEvents: {
        'change sync': 'render',
    },

    ui: {
        buttonRestore: '.btn[data-action="restore"]',
    },

    events: {
        'click @ui.buttonRestore': 'onRestoreItem',
    },

    /**
     * Is called, when an item should be restored
     * @param {object} event The click event
     */
    onRestoreItem: function(event) {
        var $button = $(event.currentTarget);
        $button.addClass('is-loading');

        this.model.collection.restoreItem(this.model, function() {
            $button.removeClass('is-loading');
            Messenger().success({
                message: App.t('settings::trash:response:restore-success'),
            });
        }, function() {
            $button.removeClass('is-loading');
            Messenger().error({
                message: App.t('settings::trash:response:restore-error'),
            });
        });
    },
});

module.exports = ImportTrashListItem;